<template>
  <v-card flat>
    <v-alert type="warning" text outlined>
      <span class="title">Erro 404. Página não localizada</span>
    </v-alert>
  </v-card>
</template>

<script>
export default {};
</script>

<style>
</style>